module.exports = __webpack_public_path__ + "img/404.cf4c0e52.png";